module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('p', {
    staticClass: "content-c",
    attrs: {
      "id": "calibre_toc_6"
    }
  }, [_c('a', {
    attrs: {
      "id": "b4"
    }
  }), _c('a', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_004#a4"
    }
  }, [_c('span', {
    staticClass: "bold5"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "16658.png",
      "src": "OEBPS/image/16658.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chapter-name"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_004#a4"
    }
  }, [_vm._v("My Wish and Prayer That You Get"), _c('span', {
    staticClass: "calibre3"
  }), _vm._v("Unstuck")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-1st-paragraph"
  }, [_vm._v("Are you living with chronic pain? Do you worry that nobody really understands your physical or emotional suffering? Are you so busy taking care of other people and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("things")]), _vm._v(" that you have brushed your own dreams aside? Have people told you that your dreams are just plain crazy at your age? Are you feeling a little overwhelmed all the time or close to the edge? Do you feel stuck? Have you been hurt so many times, that hurt is all you know, and it is your expectation of others’ impact on"), _c('span'), _vm._v("you?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("You are not alone. Every horrific story you can tell me that’s happened to you has happened to someone else in this world. Just like we all have doppelgangers somewhere who look exactly like us, someone has felt what you have felt and has experienced close to what you have experienced, some time in this lifetime. Think about it. There are an awful lot of people on planet Earth. I am not minimizing your pain, suffering, or experiences, but I am telling you that you can decide to not let it hold you back"), _c('span'), _vm._v("anymore.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("You have the God-given ability to turn things around, and to take action in order to become your superior self. You will do more than bounce back to your normal self. You will become the extraordinary person who has been glowing softly inside of you the whole time you thought you couldn’t, shouldn’t, or wouldn’t…")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It is my wish and prayer that you do not remain stuck in a beautifully, ornate bird cage, singing your glorious, heavenly song, looking and sounding so moving that it brings tears to the eyes of anyone passing by, yet "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("still")]), _vm._v(" inside that bird"), _c('span'), _vm._v("cage.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When we hold on to bitterness, anger, and hatred, it serves no one, especially not ourselves. Somehow we need to figure out how to turn it around so we do not keep living on auto pilot, and remain paralyzed in our current situation. OK, so you were screwed over in your life. People took advantage of you. You made poor choices and suffered the consequences. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("What")]), _c('em', {
    staticClass: "italic"
  }), _c('em', {
    staticClass: "italic"
  }, [_vm._v("now?")])]), _vm._v(" "), _c('p', {
    staticClass: "quote"
  }, [_c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("“Self pity in its early stages is as snug as a feather mattress. Only when it hardens does it become")]), _c('span', {
    staticClass: "bold-italic"
  }), _c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("uncomfortable.”")])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("—Maya Angelou, author")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Here is an opportunity to go deeper into what happened to you, and to organically produce a different outcome. As with all of life’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("aha")]), _vm._v(" moments, these lessons will take effort on your part. The true understanding may not come immediately after completing the soul work. As someone very close to me once said, “You cannot speed up understanding.”"), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "fn1"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_029#f1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I am often referred to as a friend, an ally, a mother-type, and a nurturer. People trust me with their most intimate, secret, vulnerable, scary, and never before shared stories and thoughts. My friends and clients know I have created a safe space for them to purge their troubles from their body and soul. Together we pick up the pieces, communicate honestly, create true connection, and create an invitation to change. We rebuild a shiny, strong "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Happy, Healthy")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("You, ")]), _vm._v("one baby step at a time, but it does take time. I’m immensely grateful for that trust. When I use my role play or writing exercises to assist in healing, I always feel a lesson is there for me as"), _c('span'), _vm._v("well.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I’m not a medical professional of any type. I am a good listener and a creative type of person. Perhaps my nurturing character and studies in childhood development have made me the type of support person that I"), _c('span'), _vm._v("am.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("In the self-reflective exercises you will find throughout this book, there are no right or wrong answers. They are for your heart, mind, notebook and eyes only, so feel completely at ease being open and honest with"), _c('span'), _vm._v("yourself.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Have you ever wanted to physically destroy your negative thoughts? The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Negative Thought Pot")]), _vm._v(" is a tool I use for my family and for my wellness workshops. We write our written fears and negative self-judgments on strips of paper, roll them up tightly into little scrolls, and place them in a clay pot. We then set the paper on fire, literally destroying those thoughts. Those thoughts and worries have no more power over us. To me, fear equals hate. Whether it is a tiny fear or a grand one, it is still a form of self hate. I say, burn it"), _c('span'), _vm._v("up.")]), _vm._v(" "), _c('p', {
    staticClass: "center_img"
  }, [_c('img', {
    attrs: {
      "alt": "qoutes",
      "src": "OEBPS/image/3.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-1st-paragraph"
  }, [_vm._v("During the written exercises in this book, if you feel someone may intrude on your personal growth and privacy by looking though your journals or tiny notebook in any way, feel free to set fire to the written work in the notebook page by page. Tear out the pages and destroy them in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Negative Thought Pot")]), _vm._v(". Do this only after meditating upon and learning from your"), _c('span'), _vm._v("answers.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Inside this book you will learn the origin of how and why some of us pick up bad habits or cling to less than ideal routines after crises in our lives. You will learn how the role of nutrition affects every aspect of our mental and physical health. You will learn about the endocrine system, the home of hormones, and then how hormones affect every system in the body. You will be exposed to the power of self-care through restorative practices. You will learn how to use daily affirmations for positive outcomes. You will learn how to use silence as a healer through different modalities. You will see how epigenetics relate to genetics and figure out how we can alter our gene expression to become the best version of ourselves, our happy, healthy"), _c('span'), _vm._v("selves.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Some of the themes I just mentioned are also discussed in my first book."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "fn2"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_029#f2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" Here, we will dig way deeper into utilizing those techniques, and discover other tools for letting go and for moving forward. We will find new answers to old"), _c('span'), _vm._v("questions.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It is my personal belief that we chose to come down here to earth from some other side (heaven, spirit world, or dimension), and that when we were on the other side, we chose to have these challenges here on earth. I think we made a sort of agreement with the universe (God, angels, All That Is). This is my belief only. I do not believe that we choose to be obese, chronically ill, afflicted with cancer, raped, abused, neglected, put down, criticized, etc., but we did choose to have some things to work on so that we could grow deeply in our soul-spot. Maybe it was a subconscious or a super-conscious"), _c('span'), _vm._v("decision.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I want you to face your superior self sooner rather than later. I don’t want you to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("get it")]), _vm._v(" at the moment of your death. I want you to get it now (or at least by the end of this"), _c('span'), _vm._v("book).")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Feeling good is worth it. Feeling great is worth the challenge, the process, the journey, and the"), _c('span'), _vm._v("efforts.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_vm._v("I invite you to lose the baggage and blame. Face your superior self. Embrace a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Happy, Healthy")]), _c('em', {
    staticClass: "italic"
  }), _c('em', {
    staticClass: "italic"
  }, [_vm._v("You.")]), _c('span')]), _vm._v(" "), _c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "calibre_pb_8"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f272480","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/HappyHealthyYou_split_008.vue
// module id = 84
// module chunks = 0